module.exports = __webpack_public_path__ + "static/media/warning.d223f038.svg";